import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionIcon,
  AccordionPanel,
  Flex,
  Icon,
  Text,
  useColorMode,
  useColorModeValue,
  theme,
} from "@chakra-ui/react";
import { useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import { AgencyContext } from "../Settings/AgencyProvider/AgencyProvider";
import { clipText } from "../../utils/utils";

export function hasActiveChild(component, pathname) {
  if (pathname.includes(component.path)) return true;
  if (component.children) {
    return component.children.some((child) => hasActiveChild(child, pathname));
  }
  return false;
}

function RenderAccordion(component) {
  const isChild = component?.isChild;
  const hasChildren = component?.children?.length > 0;
  const location = useLocation();
  const isActive = location.pathname.includes(component.path);

  const agency = useContext(AgencyContext);
  const textColor = agency?.textColor;
  const iconColor = useColorModeValue(
    textColor || theme.colors.gray[500],
    "white"
  );

  const { colorMode } = useColorMode();
  const activeTitleColor =
    colorMode === "light"
      ? isActive
        ? textColor || "black"
        : "gray"
      : "white";

  return (
    <AccordionItem
      bg={
        colorMode === "light"
          ? isActive
            ? "gray.200"
            : undefined
          : isActive
          ? "gray.600"
          : undefined
      }
      border={isChild && "none"}
      borderBottomWidth={"0px !important"}
    >
      <AccordionButton px={4} py={2} justifyContent={"space-between"}>
        <Link
          to={component.path}
          style={component?.path && { width: "100%", textAlign: "left" }}
        >
          <Flex alignItems={"center"} gap={3}>
            {component?.icon && (
              <Icon as={component.icon} size="md" color={iconColor} />
            )}
            <Text fontWeight={"bold"} color={activeTitleColor}>
              {clipText(component.title, 20)}
            </Text>
          </Flex>
        </Link>
        {hasChildren && <AccordionIcon />}
      </AccordionButton>

      {hasChildren && (
        <AccordionPanel pb={0} pt={0} pr={0}>
          <Accordion
            allowMultiple
            defaultIndex={[
              component.children.findIndex((child) =>
                hasActiveChild(child, location.pathname)
              ),
            ]}
          >
            {component.children.map((child, index) => (
              <RenderAccordion key={index} isChild={true} {...child} />
            ))}
          </Accordion>
        </AccordionPanel>
      )}
    </AccordionItem>
  );
}

const CustomAccordion = ({ navItem, forceOpen = false }) => {
  const location = useLocation();
  const shouldExpand = hasActiveChild(navItem, location.pathname);
  const defaultIndex = forceOpen || shouldExpand ? [0] : [];

  return (
    <Accordion allowMultiple defaultIndex={defaultIndex} w={"100%"}>
      <RenderAccordion {...navItem} />
    </Accordion>
  );
};

export default CustomAccordion;
